import * as angular from 'angular';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';
import { AuthService } from './auth.service';
import { detectModule } from 'go-modules/detect';

export const authServiceModule = angular.module('AuthServiceModule', [
	ngxFeatureFlagServiceModule,
	detectModule
])
	.service('authService', AuthService)
	.name;
